import { render } from "./EditPaymentMethod.vue?vue&type=template&id=3112c8f4&ts=true"
import script from "./EditPaymentMethod.vue?vue&type=script&lang=ts"
export * from "./EditPaymentMethod.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__